// /src/router/index.js

import store from "../store/";
import { createRouter, createWebHistory } from "vue-router";
import Projects from "../views/Projects.vue";
import Login from "../views/Login.vue";
import Forgot from "../views/Forgot";
import Registration from "../views/Registration";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/forgot",
    name: "forgot",
    component: Forgot,
  },
  {
    path: "/registration",
    name: "registration",
    component: Registration,
  },
  {
    path: "/",
    name: "Projects",
    component: Projects,
  },
  {
    path: "/contractors",
    name: "Contractors",
    component: () => import("../views/Contractors.vue"),
  },
  {
    path: "/documents/:projectId",
    name: "Documents",
    component: () => import("../views/Documents.vue"),
  },
  {
    path: "/estimate/:projectId",
    name: "Estimate",
    component: () => import("../views/Estimate.vue"),
  },
  {
    path: "/construction/:projectId",
    name: "Construction",
    component: () => import("../views/Construction.vue"),
  },
  {
    path: "/library",
    name: "Library",
    component: () => import("../views/Library.vue"),
  },
  {
    path: "/sklad",
    name: "Sklad",
    component: () => import("../views/Sklad.vue"),
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("../views/Settings.vue"),
  },
  {
    path: "/warehouse/:projectId",
    name: "Warehouse",
    component: () => import("../views/Warehouse.vue"),
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/Admin.vue"),
  },
  {
    path: "/inventory",
    name: "Inventory",
    component: () => import("../views/Inventory.vue"),
  },
  {
    path: "/employees",
    name: "Employees",
    component: () => import("../views/Employees.vue"),
  },
  {
    path: "/ks2/:id",
    name: "ks2",
    component: () => import("../views/Smeta/Ks2"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (localStorage.getItem("isLogged") && to.path !== "/login") {
    await store.dispatch("getUserType");
    if (store.getters.userType === "1" && to.path !== "/admin") {
      next({ name: "Admin" });
    } else if (store.getters.userType !== "1" && to.path === "/admin") {
      next({ name: "Projects" });
    } else next();
  } else {
    next();
  }
});
export default router;
